var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounTick684585(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_tick_684585",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.481,
    height: 20.481,
    viewBox: "0 0 20.481 20.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.24,20.481A10.244,10.244,0,0,1,3,3,10.244,10.244,0,0,1,17.484,17.484,10.176,10.176,0,0,1,10.24,20.481ZM5.486,9.556a.951.951,0,0,0-.673,1.628l3,2.973a.894.894,0,0,0,.661.283.934.934,0,0,0,.661-.283L15.2,8.117a.988.988,0,0,0,0-1.346.941.941,0,0,0-1.345,0l-5.38,5.38L6.158,9.839A.947.947,0,0,0,5.486,9.556Z",
    fill: "#0eaa57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounTick684585);
export default __webpack_public_path__ + "static/media/noun_tick_684585.9731431c7d432c9a447e9ae34d561864.svg";
export { ForwardRef as ReactComponent };